import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import { formatMoneda, validaMonto, formatoMonto } from "../../../util/varios";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";
import { Input, Textarea } from "../../../ui/inputs/Input";

export const ValoracionConstruccion = (props) => {
  let op = require("../../../../src/modulos/datos");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const txtId = useRef();
  const txtDescrip = useRef();
  const txtPorcen = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  let token = localStorage.getItem("jwtToken");

  const validarCampos = (e) => {
    e.preventDefault();
    var sigue = true;
    if (operacion !== 4) {
      if (txtDescrip.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Información",
          texto: "La Descripcion no debe estar vacio",
          icono: "informacion",
        });

        sigue = false;
        txtDescrip.current.focus();
      } else if (txtPorcen.current.value.trim() === "") {
        setMensaje({
          mostrar: true,
          titulo: "Información",
          texto: "El Porcentaje no debe ir Vacio",
          icono: "informacion",
        });

        sigue = false;
        txtPorcen.current.focus();
      } else if (sigue === true) {
        selectRegValor(props.operacion);
      }
    }
  };
  const onChangeOne = (event) => {
    event.target.value = event.target.value.toUpperCase();
  };
  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            } */
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };
  const cerrarModal = () => {
    props.onHideRenderizar();

    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });

    props.onHideCancela();
  };
  const selectRegValor = (operacion) => {
    let endpoint = `${op.conexion}/api/inmueble/createvalorfiscal/${operacion}`;
    let body;
    setActivate(true);

    body = {
      operacion: operacion,
      idvalorfiscconstruc: parseInt(txtId.current.value),
      descripcion: txtDescrip.current.value,
      porcentajeconstruc: txtPorcen.current.value
        .trim()
        .replace(/\./g, "")
        .replace(",", "."),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente.",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const blanquearCampos = () => {
    setActivate(false);
    setOperacion();
    setDeshabilitado();
  };

  const salir = () => {
    props.onHideCancela();
    blanquearCampos();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setDeshabilitado(props.deshabilitado);
        setOperacion(props.operacion);
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Valor Fiscal."
            : operacion === 2
            ? "Editar Valor Fiscal."
            : operacion === 3
            ? "Eliminar Valor Fiscal."
            : "Valor Fiscal de las Construcciones."}
        </h3>
        <a
          type="button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 ">
        <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap">
          <legend className="float-none w-auto m-0">
            Valor Fiscal de la Construcción
          </legend>
          <div class="col-3 m-0 p-0">
            <Input
              label="Código:"
              disabled={true}
              ref={txtId}
              defaultValue={
                props.valorFiscal ? props.valorFiscal.idvalorfiscconstruc : ""
              }
              id="inputCodigo"
            />
          </div>
          <div class="col-5 m-0 ml-auto p-0 pl-2 d-flex">
            <Input
              label="Porcentajes de las Construcciones:"
              disabled={
                operacion == 3 ? true : operacion == 4 ? true : deshabilitado
              }
              ref={txtPorcen}
              defaultValue={
                props.valorFiscal && props.valorFiscal.porcentajeconstruc
                  ? props.valorFiscal.porcentajeconstruc !== null
                    ? formatMoneda(
                        props.valorFiscal.porcentajeconstruc
                          .replace(",", "")
                          .replace(".", ","),
                        ",",
                        ".",
                        2
                      )
                    : ""
                  : ""
              }
              onKeyUp={handleInputMontoChange}
              id="inputPorcen"
            />
          </div>
          <div class="col-12 m-0 mt-2 p-0">
            <Textarea label = 'Descripción:'
              style={{ height: 70 }}
              disabled={
                operacion == 3 ? true : operacion == 4 ? true : deshabilitado
              }
              ref={txtDescrip}
              defaultValue={
                props.valorFiscal
                  ? props.valorFiscal.descripcion !== null
                    ? props.valorFiscal.descripcion.trim()
                    : ""
                  : ""
              }
              onChange={onChangeOne}
            />
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={validarCampos}
        >
          Aceptar
        </SuccessButton>
        <DangerButton ref={btnCancela} onClick={salir}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
